import { getAction, deleteAction, putAction, postAction, httpAction } from '@/api/manage'
import Vue from 'vue'
import {UI_CACHE_DB_DICT_DATA } from "@/store/mutation-types"

const getHistoryRoomScheduleList= (params)=>getAction("/room/schedule/getHistoryRoomScheduleList",params);
const getRoomList= (params)=>getAction("/room/base/queryList",params);
const getSelectDateRoomScheduleList= (params)=>getAction("/room/schedule/getSelectDateRoomScheduleList",params);
const getSelectDateRoomScheduleListPage= (params)=>getAction("/room/schedule/getSelectDateRoomScheduleListPage",params);
const getSystemTypeList= (params)=>getAction("/room/venue/getVenueList",params);
const getRoomFacilityList= (params)=>getAction("/room/facility/queryList",params);




export {
  getHistoryRoomScheduleList,
  getRoomList,
  getSelectDateRoomScheduleList,
  getSelectDateRoomScheduleListPage,
  getSystemTypeList,
  getRoomFacilityList,
}